import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LEAD_PHOTOGRAPHY } from '../../shared/constants/strings';
import { environment } from '../../../environments/environment';
import { ImageCarouselModalContentComponent } from '../../shared/components/image-carousel-modal-content/image-carousel-modal-content.component';
import { ImgUrls } from '../../shared/models/imgUrls.interface';
import Util from '../../shared/util';
import { UtilService } from '../../shared/util.service';
import { MetadataService } from '../../shared/services/metadata.service';
import { TitleService } from '../../shared/services/title.service';
import { ThumbnailWidgetComponent } from '../../shared/components/thumbnail-widget/thumbnail-widget.component';

const PHOTO_COUNT_NATURE = 71;
const PHOTO_COUNT_EVENT = 42;

@Component({
  selector: 'app-photography',
  templateUrl: './photography.component.html',
  styleUrls: ['./photography.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatDialogModule, ThumbnailWidgetComponent],
})
export class PhotographyComponent implements OnInit {
  activeImageIndexNature = 0;
  activeImageIndexEvent = 0;
  imgPath = environment.storageImgPath;
  imgPathPhotography = this.imgPath + '/photography/';
  titleImage = this.imgPath + '/start/photographer-w500.webp';
  imgUrlsNature: ImgUrls[] = [];
  imgUrlsEvent: ImgUrls[] = [];

  constructor(
    private dialog: MatDialog,
    private metadataService: MetadataService,
    private utilService: UtilService,
    private titleService: TitleService,
  ) {}

  public get LEAD_PHOTOGRAPHY() {
    return LEAD_PHOTOGRAPHY;
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Fotografie`);
    this.metadataService.updateTags(
      `Fotografie`,
      `Hier erfahren Sie alles über meine Leistungen als Fotograf. Ich fotografiere sowohl Naturereignisse als auch Events.`,
      `Fotografie natur tiere events hochzeiten partys`,
      [this.titleImage],
    );
    this.createImgUrls(1, PHOTO_COUNT_NATURE, 'carouselNature');
    this.createImgUrls(1, PHOTO_COUNT_EVENT, 'carouselEvent');
  }

  /**
   * Opens the given array of images in a carousel inside a modal.
   * @param selectedId the ID of the image to be selected at the beginning
   * @param imgUrls all images to be shown in the carousel
   */
  openImage(selectedId: number, imgUrls: ImgUrls[]): void {
    this.dialog.open(ImageCarouselModalContentComponent, {
      panelClass: 'image-carousel-dialog',
      data: { selectedId, imgUrls, altName: imgUrls[selectedId].title },
    });
  }

  selectImage(index: number, carousel: 'carouselNature' | 'carouselEvent') {
    this.setActiveIndex(carousel, index);
  }

  previousImage(carousel: 'carouselNature' | 'carouselEvent'): void {
    const { items, activeIndex } = this.getCarouselState(carousel);
    if (!items.length) return;
    const newIndex = (activeIndex - 1 + items.length) % items.length;
    this.setActiveIndex(carousel, newIndex);
  }

  nextImage(carousel: 'carouselNature' | 'carouselEvent'): void {
    const { items, activeIndex } = this.getCarouselState(carousel);
    if (!items.length) return;
    const newIndex = (activeIndex + 1) % items.length;
    this.setActiveIndex(carousel, newIndex);
  }

  getActiveImage(carousel: 'carouselNature' | 'carouselEvent'): ImgUrls | undefined {
    const state = this.getCarouselState(carousel);
    return state.items[state.activeIndex];
  }

  private createImgUrls(firstIndex: number, lastIndex: number, carousel: 'carouselNature' | 'carouselEvent') {
    switch (carousel) {
      case 'carouselNature':
        this.imgUrlsNature = [];
        for (let i = firstIndex; i <= lastIndex; i++)
          this.imgUrlsNature.push({
            w150: this.imgPathPhotography + `photo${i}-w150.webp`,
            w350: this.imgPathPhotography + `photo${i}-w350.webp`,
            w500: this.imgPathPhotography + `photo${i}-w500.webp`,
            w750: this.imgPathPhotography + `photo${i}-w750.webp`,
            w1124: this.imgPathPhotography + `photo${i}-w1124.webp`,
            w1500: this.imgPathPhotography + `photo${i}-w1500.webp`,
            full: this.imgPathPhotography + `photo${i}-w2000.webp`,
            title: `Naturfoto ${i}`,
          });
        Util.shuffle(this.imgUrlsNature);
        break;
      case 'carouselEvent':
        this.imgUrlsEvent = [];
        for (let i = firstIndex; i <= lastIndex; i++)
          this.imgUrlsEvent.push({
            w150: this.imgPathPhotography + `event${i}-w150.webp`,
            w350: this.imgPathPhotography + `event${i}-w350.webp`,
            w500: this.imgPathPhotography + `event${i}-w500.webp`,
            w750: this.imgPathPhotography + `event${i}-w750.webp`,
            w1124: this.imgPathPhotography + `event${i}-w1124.webp`,
            w1500: this.imgPathPhotography + `event${i}-w1500.webp`,
            full: this.imgPathPhotography + `event${i}-w2000.webp`,
            title: `Eventfoto ${i}`,
          });
        Util.shuffle(this.imgUrlsEvent);
    }
  }

  private getCarouselState(carousel: 'carouselNature' | 'carouselEvent') {
    switch (carousel) {
      case 'carouselNature':
        return { items: this.imgUrlsNature, activeIndex: this.activeImageIndexNature };
      case 'carouselEvent':
        return { items: this.imgUrlsEvent, activeIndex: this.activeImageIndexEvent };
    }
  }

  private setActiveIndex(carousel: 'carouselNature' | 'carouselEvent', index: number): void {
    switch (carousel) {
      case 'carouselNature':
        this.activeImageIndexNature = index;
        break;
      case 'carouselEvent':
        this.activeImageIndexEvent = index;
    }
    this.utilService.scrollToId(carousel);
  }
}
